import io from "socket.io-client";
const userId = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user"))?._id : "";

const socket = io("https://smarteduservices.com:5001", {
// const socket = io("http://localhost:5001", {
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  transports: ["websocket"],
});

socket.on('connect', () => {
  // console.log('Connected to socket server');
  socket.emit('authenticate', userId);
});
socket.on('reconnect', (attemptNumber) => {
  // console.log('Reconnected to server after ' + attemptNumber + ' attempts');
  // Re-authenticate after reconnection
  socket.emit('authenticate', userId);
});
socket.on('reconnect_attempt', (attemptNumber) => {
  // console.log('Attempting to reconnect:', attemptNumber);
});
socket.on('disconnect', (reason) => {
  // console.log('Disconnected from socket server:', reason);
});

const emit = (text, data) => {
  socket.emit(text, data);
};

export const emitAuthenticate = (id) => {
  emit("authenticate", id);
};

export const emitNotification = (notification) => {
  emit("notification", notification);
};

export const emitTaskNotification = (body, task, roles, freelancer = null, offer = false, admin = false) => {

  let audience = [];
  if(roles.includes("customerService")) {
    audience.push({user: task.created_by?._id, seen: false});
  }
  if(roles.includes("customerService")) {
    audience.push({user: task.show_created?._id, seen: false});
  }
  if(roles.includes("freelancer")) {
    audience.push({user: task.freelancer?._id, seen: false});
  }
  if(roles.includes("specialistService")) {
    audience.push({user: task.accepted_by?._id, seen: false});
  }
  if(roles.includes("academicReviewer")) {
    audience.push({user: task.reviewed_by?._id, seen: false});
  }
  if(roles.includes("admin")) {
    admin = true;
  }

  if (freelancer) {
    audience.push({user: freelancer, seen: false});
  }

  if (audience.length === 0 && !admin && !offer) {
    return;
  }
  emitNotification({
    body,
    audience,
    type: "task",
    link: `/task/${task?._id}`,
    offer,
    admin
  });
};

export default socket;